import React from 'react';
import DatePicker from 'react-datepicker';
import { Field } from 'react-final-form';
import { isValid } from 'date-fns';

import { FormFeedback } from './index';

import 'react-datepicker/dist/react-datepicker.css';
import './FormDateInput.scss';

const renderTimeInput = ({
  input,
  meta,
  inputOnChange,
  screenDimensions,
  disabled, 
  id,       
  ...datePickerProps
}) => {
  const timeInputProps = {
    ...input,
    ...datePickerProps,
    value: input.value ? new Date(input.value) : null,
    onChange: e => {
      input.onChange(e);
      if (inputOnChange) inputOnChange(e);
    }
  };

  return (
    <React.Fragment>
      <DatePicker
        {...timeInputProps}
        id={id}
        disabled={disabled}
        className="form-input__control time-input"
        selected={
          isValid(new Date(timeInputProps.value))
            ? new Date(timeInputProps.value)
            : null
        }
        withPortal={screenDimensions.width <= 1023}
        dateFormat="h:mm aa"
        showTimeSelect
        showTimeSelectOnly
      />

      {meta.submitError && !meta.modifiedSinceLastSubmit && (
        <FormFeedback positive={false}>{meta.submitError}</FormFeedback>
      )}
      {meta.error && meta.dirty && (
        <FormFeedback positive={false}>{meta.error}</FormFeedback>
      )}
    </React.Fragment>
  );
};

export default props => {
  const {
    name,
    initialValue,
    validate,
    labelRenderer,
    disabled,
    ...datePickerProps
  } = props;

  const screenDimensions = {
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768
  };

  return (
    <div>
      {labelRenderer && (
        <label className="form-input" htmlFor={name}>
          {typeof labelRenderer === 'function' ? labelRenderer() : labelRenderer}
        </label>
      )}
      
      <Field
        {...datePickerProps}
        name={name}
        id={name} 
        disabled={disabled}
        initialValue={initialValue} 
        component={renderTimeInput}
        screenDimensions={screenDimensions}
        validate={validate}
      />
    </div>
  );
};
